const AuthTypes = {
  LOGIN_LOADING: "LOGIN_LOADING",
  LOGIN_ERROR: "LOGIN_ERROR",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",

  VERIFY_LOADING: "VERIFY_LOADING",
  VERIFY_ERROR: "VERIFY_ERROR",
  VERIFY_SUCCESS: "VERIFY_SUCCESS",

  LOGOUT: "LOGOUT",
};

export default AuthTypes;
